/* eslint-disable */
// @ts-ignore

window.tokenFunction = () => {};
window.emptyArray = [];
window.emptyObject = {};
window.defaultClient = {};
window.defaultApi = {};
window.defaultAccountRef = {};
